// const LeaderboardPage = () => import('./list/LeaderboardPage.vue');

import LeaderboardPage from "./list/LeaderboardPage.vue";

const routes = [
  {
    path: '/leaderboard',
    name: 'leaderboard',
    component: LeaderboardPage,
    meta: {
      title: 'match',
      requiresAuth: true,
    }
  }
];

export default routes;
